
















































import { Component, Vue, Emit } from 'vue-property-decorator'
import { UserStore, userInfoTypes } from '@/store/modules/User'
import { letterCities, city } from '@/api/com'

@Component({
  name: 'City'
})
export default class City extends Vue {
  // 国家
  private nation: any[] = []

  // 用户选中的城市
  private cityValue = ''

  // 输入框的值
  private value = ''

  // 原始处理过的数据
  private labels:any [] = []

  // 筛选过后的数据
  private searchList: any[] = []

  private cityActive = 0

  // private areaId = 0

  // 最终显示数据
  get list () {
    if (this.searchList.length) return this.searchList
    return this.labels
  }

  get userInfo (): userInfoTypes {
    return UserStore.userInfo
  }

  // 获取字母城市分类
  getLetterCities () {
    // const pathName = this.$route.name
    // const parentMchId = pathName === '首页' ? '' : (this.userInfo.parentMchId || '')
    letterCities({
      // parentMchId: parentMchId,
      areaId: Number(this.cityValue) || 0
    })
      .then(res => {
        if (res.success) {
          this.handleLetterCities(res.data || [])
        } else {
          this.$message.error({
            message: res.msg
          })
        }
      })
  }

  // 处理城市分类数据
  handleLetterCities (arr) {
    let num = 7
    if (arr.length <= 20 && arr.length > 10) {
      num = 5
    } else if (arr.length <= 10) {
      num = 3
    }
    const labels: any[] = []
    let areas: any[] = []
    let labelStr = ''
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i]
      labelStr += item.letter
      areas = [...areas, ...item]
      if (i % num === 0 && i !== 0) {
        labels.push({
          letter: labelStr,
          areas
        })
        labelStr = ''
        areas = []
      }
    }
    this.labels = labels
  }

  changeSearch () {
    console.log(this.value)
    if (/^[a-zA-Z]/g.test(this.value)) {
      console.log('英文开头')
      const value = this.value.toUpperCase()
      let i: string | number = ''
      let j: string | number = ''
      for (let index = 0; index < this.labels.length; index++) {
        const items = this.labels[index]
        if (items.letter.includes(value)) {
          i = Number(index)
          for (const key in items.areas) {
            const item = items.areas[key]
            if (item.letter === value) {
              j = Number(key)
              break
            }
          }
          break
        }
      }
      if (i !== '' && j !== '') {
        const arr = [{
          letter: this.value.toUpperCase(),
          areas: [this.labels[i].areas[j]]
        }]
        this.$set(this, 'searchList', arr)
      } else {
        this.$set(this, 'searchList', [])
      }
    } else if (/^[\u4e00-\u9fa5]/g.test(this.value)) {
      console.log('中文开头')
      const v = this.searchChinese(this.value)
      console.log('返回结果->', v)
    } else if (!this.value) {
      this.searchList = []
    }
  }

  searchChinese (value, arr = this.labels) {
    for (let index = 0; index < arr.length; index++) {
      const item = arr[index]
      if (item.areas) {
        this.searchChinese(value, item.areas)
      } else if (item.areaName.includes(value)) {
        // console.info('匹配到的结果->', item)
        // console.info('匹配到的结果->', item.areaName)
        if (this.searchList[0] && this.searchList[0].letter === item.letter) {
          this.searchList[0].areas[0].areas.push(item)
          this.searchList.forEach(item => {
            item.areas.forEach(it => {
              it.areas = it.areas.filter(
                (item, index, self) => index === self.findIndex(t => t.areaId === item.areaId)
              )
            })
          })
        } else {
          const list = {
            letter: item.letter,
            areas: [
              {
                letter: item.letter,
                areas: [{
                  ...item
                }]
              }
            ]
          }
          this.$set(this, 'searchList', [list])
        }
      }
    }
  }

  getCity () {
    const params = {
      parentId: 0
    }
    city(params)
      .then(res => {
        if (res && res.length) {
          this.nation = res
          this.cityValue = res[0].areaId
        }
        this.getLetterCities()
      }).catch(() => {
        this.getLetterCities()
      })
  }

  // 点击城市
  @Emit('change')
  clickCityItem (item): any {
    return item
  }

  mounted (): void {
    this.getCity()
  }
}
